enum FileCategoryEnum {
  ACCIDENT_DRAWING = 13,
  ARCHIVE = 14,
  ASSESSMENT = 3,
  ASSESSMENT_INVOICE = 26,
  ASSESSMENT_INVOICE_AUDIT = 31,
  ASSESSMENT_ORDER = 47,
  AUTHORITY = 7,
  CALCULATION = 59,
  CANCELLATION_POLICY = 53,
  CLIENT_GENERALCLIENT_GENERAL = 32,
  COLLECTING_UPLOAD = 39,
  CONTRACT_DOCUMENT = 56,
  COST_ACQUISITION = 46,
  COST_ACQUISITION_INSURANCE = 57,
  COST_ESTIMATE = 17,
  COURTESYCAR_CONTRACT = 29,
  DAMAGE_IMAGE = 62,
  DAMAGE_RECORD_ARCHIVE = 54,
  DAT_DAMAGE_CALCULATION = 25,
  ELECTRONIC_RECORD = 33,
  ET_ORDER = 66,
  GDPR_DATA_PROCESSING_CONTRACT = 42,
  IMPORT = 18,
  INSURANCE_LETTER = 24,
  LAWYER_AUTHORITY = 6,
  LAWYER_COMMUNICATION = 63,
  LEASING_OR_BANK = 34,
  NOTE_CODE_ATTACHMENT = 15,
  OTHER_DOCUMENT = 2,
  OTHER_INSURANCE_DOCUMENT = 52,
  OTHER_INVOICE = 10,
  OTHER_WILDLIFE_ACCIDENT_CERTIFICATE = 70,
  PAINT_SHOP_INVOICE = 60,
  PAYMENT_ORDER = 22,
  PERSONAL_INJURY = 40,
  PICTURE = 1,
  POLICE_REPORT = 27,
  PRE_CALCULATION_CAR_DEALER = 58,
  PRIVACY_POLICY = 43,
  PROCURATION_CONFIRMATION = 19,
  PROTOCOL_ELECTRIC_VEHICLE = 64,
  REGISTRATION_DOCUMENT = 20,
  RENT_CONTRACT = 4,
  RENT_INVOICE = 9,
  RENT_OTHER = 50,
  RENT_VEHICLE_REGISTRATION_DOCUMENT = 41,
  REPAIR_EXPERT_ASSISTANCE_COSTS = 67,
  REPAIR_INVOICE = 8,
  REPAIR_ORDER = 12,
  REPAIR_OTHER = 49,
  REPAIR_SEQUENCE_PLAN = 5,
  RESIDUAL_PURCHASE = 28,
  SCHWACKE_CLASSIFICATION = 44,
  SECRECY_RELEASE = 23,
  TEMPFILE = 16,
  THUMBNAIL = 71,
  TOWING_INVOICE = 21,
  VEHICLE_LICENSE = 30
}

export default FileCategoryEnum;
